import React from "react";
import { ArrowDown } from "lucide-react";
import { usePrice } from "@/lib/price";

const stack = [
  ["Playbook Directory", 197],
  ["Job Directory · 338K+ live", 197],
  ["Resume Match", 197],
  ["AI Toolbox · 252 entries", 197],
  ["Resume Builder", 197],
  ["Readiness Simulator", 197],
  ["OmniCut", 197],
  ["OmniScript", 197],
  ["Community", 197],
];

export default function ValueStack() {
  const total = stack.reduce((s, [, p]) => s + p, 0);
  const { price, cap } = usePrice();
  return (
    <section
      id="value"
      data-testid="value-stack"
      className="border-b-4 border-[#0a0a0a] bg-[#FDFBF7]"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-20 md:py-28">
        <div className="text-center mb-12 reveal">
          <div className="font-accent text-sm bg-[#0055FF] text-white inline-block px-3 py-1 mb-4">
            PRICE ANCHOR
          </div>
          <h2 className="font-display text-5xl md:text-6xl lg:text-7xl">
            9 tools.{" "}
            <span className="bg-[#FFE600] px-3">{price}.</span>
          </h2>
          <p className="font-mono-body mt-5 max-w-xl mx-auto text-[#0a0a0a]/75 text-base">
            Each tool standalone is the price of a SaaS month. Bundled,
            forever, for less than a sandwich.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-8 items-start">
          <div className="lg:col-span-7 bg-white border-4 border-[#0a0a0a] shadow-brutal p-6 md:p-8 reveal">
            <div className="font-accent text-xs bg-[#0a0a0a] text-[#FFE600] inline-block px-2.5 py-1 mb-5">
              ITEMIZED · PERCEIVED MARKET VALUE
            </div>
            <ul className="divide-y-2 divide-dashed divide-[#0a0a0a]/30">
              {stack.map(([name, price]) => (
                <li
                  key={name}
                  className="flex items-center justify-between py-3.5"
                >
                  <span className="font-mono-body text-[15px]">{name}</span>
                  <span className="font-display text-[15px] line-through opacity-50">
                    ${price}
                  </span>
                </li>
              ))}
              <li className="flex items-center justify-between pt-5 mt-2 border-t-4 border-[#0a0a0a]">
                <span className="font-accent text-sm">STACK VALUE</span>
                <span className="font-display text-3xl line-through opacity-70">
                  ${total.toLocaleString()}
                </span>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-5 reveal">
            <div className="relative bg-[#FF3B30] text-white border-4 border-[#0a0a0a] shadow-brutal-lg p-8 md:p-10">
              <span className="absolute -top-5 -right-3 bg-[#00FF66] text-[#0a0a0a] border-4 border-[#0a0a0a] px-3 py-1.5 font-accent text-xs shadow-brutal-sm rotate-[8deg]">
                YOU PAY
              </span>
              <div className="font-accent text-sm">YOUR PRICE TODAY</div>
              <div className="flex items-end gap-3 mt-2">
                <div className="font-display text-[100px] sm:text-[140px] md:text-[180px] leading-[0.82]">
                  {price}
                </div>
                <div className="pb-6 font-mono-body text-sm font-bold">
                  one-time
                  <br />
                  lifetime
                </div>
              </div>
              <p className="mt-5 font-mono-body text-[14px] leading-relaxed">
                First {(cap || 2500).toLocaleString()} members lock {price}. After that the one-time price
                climbs toward{" "}
                <span className="bg-[#FFE600] text-[#0a0a0a] px-1.5">$197</span>
                . We don&apos;t run countdown timers — we just raise the price.
              </p>
              <a
                href="https://whop.com/checkout/plan_hfsvR7lsOjQds"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="value-cta"
                className="hover-pop mt-7 inline-flex items-center gap-2 bg-[#FFE600] text-[#0a0a0a] border-4 border-[#0a0a0a] px-5 py-3.5 font-accent text-base shadow-brutal"
              >
                LOCK {price} NOW <ArrowDown size={16} strokeWidth={3} className="rotate-[-45deg]" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
